import { FC } from 'react';

import VideoModal from 'src/components/common/modal/videoModal';

const CheckConditionsModal: FC = () => (
    <VideoModal videoUrl="https://www.youtube.com/watch?v=Ea83dZEpfzQ&ab_channel=apadua" />
);

export default CheckConditionsModal;
